module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fafafa"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isWaitApproveOrder),
      expression: "isWaitApproveOrder"
    }],
    staticClass: "order-subtitle"
  }, [_vm._v("\n      您的订单已提交课题组审批人，请等待审批。\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderDetail && _vm.orderDetail.status === 14),
      expression: "orderDetail && orderDetail.status === 14"
    }],
    staticClass: "order-subtitle"
  }, [_vm._v("\n      您的订单已提交技术审核，技术审核预计在"), (new Date().getHours() >= 17 && new Date().getMinutes() >= 30) ? _c('span', [_vm._v("明天")]) : _vm._e(), _vm._v("17:30完成\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderDetail && _vm.orderDetail.status === 16),
      expression: "orderDetail && orderDetail.status === 16"
    }],
    staticClass: "order-subtitle"
  }, [_vm._v("\n      您的订单未通过技术审核，未通过原因：" + _vm._s(_vm.orderDetail && _vm.orderDetail.remark) + "\n    ")]), _vm._v(" "), (_vm.orderDetail) ? _c('div', {
    staticClass: "order-detail-container"
  }, [_c('div', {
    staticClass: "order-detail-content",
    style: ({
      'padding-bottom': _vm.showPlaceHolder ? '85px' : '50px',
    })
  }, [_c('div', {
    staticClass: "order-content-block",
    style: ({
      'margin-top': _vm.isWaitApproveOrder ? '25px' : '0'
    })
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "81px"
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-didian research-font-color",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.expressAddress || '无收货地址'))]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.expressName) + "\n                  " + _vm._s(_vm.orderDetail.expressMobile))])])]), _vm._v(" "), _vm._t("addressOperation", null, null, {
    orderDetail: _vm.orderDetail
  })], 2), _vm._v(" "), (_vm.lastExpressInfo && _vm.expressTrack.length > 0) ? _c('div', {
    staticClass: "full-split-line"
  }) : _vm._e(), _vm._v(" "), (_vm.lastExpressInfo && _vm.expressTrack.length > 0) ? _c('div', {
    staticClass: "block-address"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "t": "1691040315076",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "6515",
      "width": "16",
      "height": "16",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M770.24115 684.200623c-47.547529 0-86.080383 38.54103-86.080383 86.0998 0 47.557749 38.531832 86.098778 86.080383 86.098778 47.546507 0 86.079361-38.54103 86.079361-86.098778C856.319489 722.740631 817.787657 684.199601 770.24115 684.200623z",
      "fill": "#5878fa",
      "p-id": "6516"
    }
  }), _c('path', {
    attrs: {
      "d": "M933.255409 476.888655 856.319489 339.800399c-15.735058-18.968527-26.360335-34.43992-51.647617-34.43992L684.159745 305.360479 684.159745 202.039697c0-18.968527-15.467305-34.438898-34.431745-34.438898L98.814978 167.600798C79.850539 167.600798 64.383234 183.07117 64.383234 202.039697l0 516.598802c0 18.970571 15.467305 34.440942 34.431745 34.440942l68.661142 0C175.919521 693.748758 226.558467 647.81081 288.191617 647.81081S400.464735 693.748758 408.907114 753.079441l240.617517-0.034747c8.47406-59.325573 59.113006-105.233884 120.716519-105.233884 61.634172 0 112.272096 45.93897 120.715497 105.268631l34.229397 0C944.149461 753.079441 959.616766 737.60907 959.616766 718.639521c0 0 0-139.573653 0-172.199601C959.615745 513.814994 933.255409 476.888655 933.255409 476.888655zM718.592511 546.43992 718.592511 374.240319l84.229621 0c5.547178 0 13.249661 8.138858 13.249661 8.138858l72.493477 134.801118c6.42095 9.450028 13.383537 20.650667 13.383537 29.259625L718.592511 546.43992z",
      "fill": "#5878fa",
      "p-id": "6517"
    }
  }), _c('path', {
    attrs: {
      "d": "M288.191617 684.200623c-47.547529 0-86.080383 38.54103-86.080383 86.0998C202.112255 817.858172 240.64511 856.399202 288.191617 856.399202s86.080383-38.54103 86.080383-86.098778C374.272 722.740631 335.738124 684.199601 288.191617 684.200623z",
      "fill": "#5878fa",
      "p-id": "6518"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-detail",
    on: {
      "click": function($event) {
        return _vm.$emit('goToExpressInfo')
      }
    }
  }, [_c('span', {
    staticClass: "express-opcode-color"
  }, [_vm._v(_vm._s(_vm.lastExpressInfo.opcode))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "express-text-color",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(_vm._s(_vm.lastExpressInfo.remark))]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-lujing",
    staticStyle: {
      "font-size": "5px",
      "position": "absolute",
      "right": "30px"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "express-text-color"
  }, [_vm._v(_vm._s(_vm.lastExpressInfo.acceptTime))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "35px"
    }
  }, [_c('span', {
    staticClass: "deep-text-color",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderDetail.orderNo))]), _vm._v(" "), _c('div', {
    staticClass: "copy-orderno light-text-color",
    attrs: {
      "data-clipboard-text": _vm.orderDetail.orderNo,
      "id": "tag-copy"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("\n              复制\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _vm._l((_vm.orderDetail.itemList), function(item, i) {
    return _c('div', [_c('gc-order-product', {
      attrs: {
        "item": item,
        "order": _vm.orderDetail,
        "show-product-contract-no": _vm.showProductContractNo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "block-item light-text-color",
      staticStyle: {
        "height": "35px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "flex-start"
      }
    }, [((item.contractNo && item.contractNo.indexOf('GVAP') < 0) || !item.contractNo) ? _c('div', {
      staticClass: "return-btn research-font-color",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('goToProductInfo', item)
        }
      }
    }, [_vm._v("产品详情\n                ")]) : _vm._e(), _vm._v(" "), (item.contractNo && item.contractNo.indexOf('GVAP') < 0) ? _c('div', {
      staticClass: "return-btn research-font-color",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('goToProgressInfo', item)
        }
      }
    }, [_vm._v("\n                  进展查询\n                ")]) : _vm._e(), _vm._v(" "), _vm._t("productOperations", null, null, {
      item: item,
      orderDetail: _vm.orderDetail
    })], 2), _vm._v(" "), _c('span', {
      staticClass: "research-font-color"
    }, [_vm._v("¥ " + _vm._s(_vm.emkt.formatPrice(item.price)))])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item light-text-color",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("商品总额")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.initPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "block-item light-text-color",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("优惠折扣")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.discountPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "block-item light-text-color",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("运费")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.expressPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.itemListLength) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.orderDetail.price)))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "order-content-block"
  }, [_c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("结算方式")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.getBalanceTypeName()))])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.getPayTypeName()))])]), _vm._v(" "), (_vm.orderDetail.sfQuoteNo) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("报价编号")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.sfQuoteNo))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.getDeliverMethod()))])]), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "deep-color"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v(_vm._s(_vm.orderDetail.orderTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_vm._t("orderOperations", null, null, {
    orderDetail: _vm.orderDetail
  })], 2), _vm._v(" "), _c('gc-footer-placeholder', {
    attrs: {
      "show-place-holder": _vm.showPlaceHolder
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166e6249","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/components/GcOrderDetailBase.vue
// module id = 1548
// module chunks = 8